import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import { ReactComponent as AccountIcon} from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-account.svg";
import { ProgramContainer } from "../entities/formTemplateDataType";
import SocialMediaComponent from "./SocialMediaComponent";
import CustomPopup from "../runtimeComponent/subComponent/PopupComponent";
import { ModalComponent } from "../runtimeComponent/subComponent/ModalComponent";
import { UserProfile } from "../entities/CxpType";
import { MenuOptions, menuOptions, USER_PROFILE, withSignOutLast } from "../entities/Constants";
import InboxNotificationComponent from "../runtimeComponent/subComponent/InboxNotificationComponentj";
import { cleanup, clearSessionStorage } from "../security/PublicSecure";
import { logout as bpsLogout } from "../security/BpsSecure";
import TrackPageView from "../utilities/TrackPageView";
import SessionStorageService from "../services/SessionStorageService";
import { getEnvVar } from "../config/RuntimeConfig";
import { OntarioConfirmDialog } from "./OntarioConfirmDialog";

interface Props {
  programContainer: ProgramContainer;
  profile?: UserProfile
  isEng: boolean;
  callback;
  callbackProgramContainer;
}
type ActivePanel = 'inbox' | 'profile' | null;

interface State {
  isEng: boolean;
  activePanel: ActivePanel;
  helpActive: boolean;
  menuOptions?: MenuOptions[]
  showExitDialog: boolean;
  exitDestination: string;
}

const EXIT_POPUP_EXCLUDED_ROUTES: Record<string, string[]> = {
  VECON: [
    "you-are-not-eligible",
    "your-application-has-been-submitted",
    "adult-change-of-name-application",
  ],
};

export class ServiceOntarioHeaderComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isEng: this.props.isEng,
      activePanel: null,
      helpActive: false,
      menuOptions: this.getConfiguredMenuOptions(),
      showExitDialog: false,
      exitDestination: "",
    };
    // this.handleMenuItem = this.handleMenuItem.bind(this);
  }

  componentDidMount() {
    if (this.props.programContainer.EnableExitPopup === "Y" && this.props.programContainer.CategoryId?.toUpperCase() === "VECON") {
      window.addEventListener("beforeunload", this.handleBeforeUnload);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  isExcludedRoute = (): boolean => {
    const appId = this.props.programContainer.CategoryId?.toUpperCase();
    const excludedRoutes = EXIT_POPUP_EXCLUDED_ROUTES[appId] || [];
    const url = window.location.href;
    return excludedRoutes.some(route => url.includes(route));
  }

  handleBeforeUnload = (e: BeforeUnloadEvent) => {
    if (this.isExcludedRoute()) {
      return;
    }
    if (this.props.programContainer.IsDirty) {
      e.preventDefault();
      e.returnValue = "";
    }
  }

  getConfiguredMenuOptions = (): MenuOptions[] => {
    // Parse HeaderMenuConfig to get selected menu items
    if (this.props.programContainer.HeaderMenuConfig) {
      const configuredIds = this.props.programContainer.HeaderMenuConfig
        .split(',')
        .map(id => id.trim())
        .filter(id => id.length > 0);

      return withSignOutLast(menuOptions.filter(option => configuredIds.includes(option.id)));
    }

    // Return empty array if no configuration is provided
    return [];
  }

  getSessionProfile = (): UserProfile | undefined => {
    const storedProfile = sessionStorage.getItem(USER_PROFILE) || sessionStorage.getItem("userProfile");
    if (!storedProfile) {
      return undefined;
    }
    try {
      return JSON.parse(storedProfile) as UserProfile;
    } catch {
      return undefined;
    }
  };

  handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const ontarioUrl = this.props.isEng
      ? "https://www.ontario.ca/page/government-ontario"
      : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";

    const isExcludedRoute = this.isExcludedRoute();
    if (!isExcludedRoute && this.props.programContainer.EnableExitPopup === "Y" && this.props.programContainer.IsDirty) {
      if (!this.props.isEng) {
        this.props.programContainer.ExitPopupTitle = "";
        this.props.programContainer.ExitPopupMessage = "";
        this.props.programContainer.ExitPopupStayButtonLabel = "";
        this.props.programContainer.ExitPopupExitButtonLabel = "";
      }
      this.setState({ showExitDialog: true, exitDestination: ontarioUrl });
    } else {
      window.location.href = ontarioUrl;
    }
  }

  handleConfirmExit = () => {
    const { exitDestination } = this.state;
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    this.setState({ showExitDialog: false }, () => {
      if (exitDestination) {
        window.location.href = exitDestination;
      }
    });
  }

  handleCancelExit = () => {
    this.setState({ showExitDialog: false, exitDestination: "" });
  }

 handleMenuItem = async (e) => {
     const menu = document.getElementById('header-menu-popup');
     if (!menu || !menu.contains(e.target as Node)) {
       this.setState({ activePanel: null });
       return;
     }
 
     let app = this.props.programContainer.CategoryId.toLowerCase();
 
     const target = e.target as HTMLElement;
     const id =
       target.id ||
       target.closest?.('li[data-menu-id]')?.getAttribute('data-menu-id') ||
       (target.closest?.('a[id]') as HTMLAnchorElement | null)?.id;
 
     if (!id) {
       return;
     }
 
     const menuItem = this.state.menuOptions.find(option => option.id === id);
     if (menuItem) {
       e.preventDefault();
       let url = '';
       if (id === 'signout') {
         const postLogoutRedirectUri = `${window.location.origin}/on-form/${this.props.isEng ? '' : 'fr/'}${app}`;
         const isBpsFlow =
           this.props.programContainer.AuthRequired === "bps" ||
           !!this.props.programContainer.BpsConfig?.logoutEndpoint;

         if (isBpsFlow) {
           // BPS logout URL is resolved via programContainer.BpsConfig.logoutEndpoint
           bpsLogout(this.props.programContainer, postLogoutRedirectUri);
         } else {
           // Public Secure logout (existing behavior)
           const idToken = SessionStorageService.getPSIDToken();
           const logoutUrl =
             `${getEnvVar('PUBLIC_SECURE_ISSUER')}/v1/logout` +
             `?id_token_hint=${encodeURIComponent(idToken)}` +
             `&post_logout_redirect_uri=${encodeURIComponent(getEnvVar('PUBLIC_SECURE_SIGNOUT_REDIRECT_URI'))}`;

           cleanup(app, this.props.programContainer);

           setTimeout(() => {
             window.location.href = logoutUrl;
           }, 200); // Small delay ensures clean redirect
         }
       } else {
         url = this.getMenuLinkUrl(menuItem);
         if (!this.isExcludedRoute() && this.props.programContainer.EnableExitPopup === "Y" && this.props.programContainer.IsDirty) {
           if (!this.props.isEng) {
             this.props.programContainer.ExitPopupTitle = "";
             this.props.programContainer.ExitPopupMessage = "";
             this.props.programContainer.ExitPopupStayButtonLabel = "";
             this.props.programContainer.ExitPopupExitButtonLabel = "";
           }
           this.setState({ showExitDialog: true, exitDestination: url });
           return;
         }
         window.location.assign(url);
       }
       // 
     }
     // cleanup(app, this.props.programContainer);
     this.setState({ activePanel: null });
   }

  getMenuLinkUrl = (option: MenuOptions) => {
    let app = this.props.programContainer.CategoryId.toLowerCase();
    if (app === "otrip") app = "otris";

    const lang = this.props.isEng ? "en" : "fr";
    let url = option[`link-${lang}`];

    return url;
  };

  addFrToUrl = () => {
    const enUrlString = window.location.href;
    sessionStorage.setItem("previousUrl", enUrlString);
    const frUrlString = enUrlString.replace("/on-form/", "/on-form/fr/");
    window.history.pushState({}, "", frUrlString);
    sessionStorage.setItem("languageChange", "true");
    TrackPageView(this.props.programContainer);
  };

  removeFrToUrl = () => {
    const url = window.location.href;
    sessionStorage.setItem("previousUrl", url);
    sessionStorage.setItem("languageChange", "true");
    if (url.includes("/fr")) {
      const newUrl = url.replace("/fr", "");
      window.history.pushState(null, "", newUrl);
    }

    TrackPageView(this.props.programContainer);
  };

  generateHeader = () => {
    const HtmlToReactParser = require("html-to-react").Parser;
    const htmlToReactParser = new HtmlToReactParser();
    let parsedCustomHeader = null;

    parsedCustomHeader = htmlToReactParser.parse(
      this.props.isEng
        ? this.props.programContainer.CustomApplicationHeader
        : this.props.programContainer.CustomApplicationHeaderFRA
    );

    let app = this.props.programContainer.CategoryId?.toLowerCase();
    if (app === "otrip") app = "otris";

    if (this.state.isEng) {
      localStorage.setItem("cxp-i18n", "en");
    } else {
      localStorage.setItem("cxp-i18n", "fr");
    }

    //console.log("profile and menu: ", this.props.profile, this.state.menuOptions);
    console.log(window.location.href);
    //need to be reworked. hardcoded for PLP
    const NoLang =
      window.location.href.indexOf(
        "your-order-is-complete-and-is-being-reviewed"
      ) > -1 && window.location.href.toUpperCase().indexOf("PLP") > -1;

    const activeProfile =
      this.props.profile ||
      this.props.programContainer.Profile ||
      this.getSessionProfile();
    const hasProfile = !!activeProfile?.userId;

    return (
      <div className="documentation-only--application" z-index={1000}>
        <div className="ontario-header__container">
          <header
            className="ontario-service-header ontario-header"
            id="ontario-header"
          >
            <div className="ontario-row">
              <div className="ontario-columns ontario-small-6 ontario-service-header__logo">
                <a
                  href={
                    this.props.isEng
                      ? "https://www.ontario.ca/page/government-ontario"
                      : "https://www.ontario.ca/fr/page/gouvernement-de-lontario"
                  }
                  onClick={(e) => this.handleLogoClick(e)}
                >
                  <img src={logo} alt="Ontario.ca homepage"/>
                </a>
              </div>
              <div className="ontario-columns ontario-small-6 ontario-service-header__lang-toggle">
                {NoLang ||
                  (!this.props.programContainer.EnglishOnly && (
                    <button
                      className="ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline"
                      lang={this.props.isEng ? "fr" : "en"}
                      onClick={() => {
                        if (this.state.isEng) {
                          localStorage.setItem("cxp-i18n", "fr");
                          this.addFrToUrl();
                        } else {
                          localStorage.setItem("cxp-i18n", "en");
                          this.removeFrToUrl();
                        }
                        this.setState({ isEng: !this.props.isEng }, () =>
                          this.props.callback(!this.props.isEng)
                        );
                      }}
                    >
                      {this.props.isEng ? "Français" : "English"}
                    </button>
                  ))}
              </div>
            </div>
          </header>
          <section className="ontario-service-subheader">
            <div className="subheader">
              <div className="ontario-service-subheader__heading-container">
                <p
                  className="ontario-service-subheader__heading"
                  style={{
                    display:
                      this.props.programContainer.SocialMedia == "Y"
                        ? "none"
                        : "block",
                  }}
                >
                  <a
                    href="https://www.ontario.ca/page/government-ontario"
                    className="ontario-service-subheader__link"
                    onClick={(e) => this.handleLogoClick(e)}
                  >
                    ServiceOntario
                  </a>
                </p>
                <p className="ontario-service-subheader__description">
                  {this.props.programContainer.CategoryId?.toUpperCase().startsWith(
                    "BXP"
                  )
                    ? parsedCustomHeader
                    : this.props.isEng
                    ? this.props.programContainer.Name
                    : this.props.programContainer.NameFRA}
                </p>
                <div
                  style={{
                    display:
                      this.props.programContainer.SocialMedia == "Y"
                        ? "block"
                        : "none",
                  }}
                >
                  <SocialMediaComponent
                    isEng={this.props.isEng}
                    GATrackingID={this.props.programContainer.GATrackingID}
                  ></SocialMediaComponent>
                </div>
              </div>

              <div
                className="ontario-service-subheader__menu-container"
                style={{
                  display: this.props.programContainer.HelpOption
                    ? "block"
                    : "none",
                }}
              >
                <ul className="ontario-service-subheader__menu">
                  <li>
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.setState({ helpActive: !this.state.helpActive })
                      }
                    >
                      {this.props.isEng ? "Help" : "Aider"}
                    </a>
                  </li>
                </ul>
              </div>
              <ModalComponent
                modalIsOpen={this.state.helpActive}
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => this.setState({ helpActive: false })}
              >
                {this.props.isEng
                  ? htmlToReactParser.parse(
                      this.props.programContainer.HelpHeader
                    )
                  : htmlToReactParser.parse(
                      this.props.programContainer.HelpHeaderFRA
                    )}
                {this.props.isEng
                  ? htmlToReactParser.parse(
                      this.props.programContainer.HelpRichText
                    )
                  : htmlToReactParser.parse(
                      this.props.programContainer.HelpRichTextFRA
                    )}
                {this.props.isEng
                  ? htmlToReactParser.parse(
                      this.props.programContainer.HelpFooter
                    )
                  : htmlToReactParser.parse(
                      this.props.programContainer.HelpFooterFRA
                    )}
                <button
                  className="ontario-button ontario-button--primary"
                  onClick={() => this.setState({ helpActive: false })}
                >
                  {this.props.isEng ? "Close" : "Fermer"}
                </button>
              </ModalComponent>
              {hasProfile && (
                  <div className="header-submenu">
                    <div role="navigation" aria-label="Main">
                      <InboxNotificationComponent
                        programContainer={this.props.programContainer}
                        lang={this.props.isEng ? "en" : "fr"}
                        isOpen={this.state.activePanel === 'inbox'}
                        onOpenChange={(open) => this.setState({ activePanel: open ? 'inbox' : null })}
                      />

                      <button
                        className={`header__menu-toggler header-button submenu_button header-button--with-outline`}
                        aria-expanded={this.state.activePanel === 'profile'}
                        aria-labelledby="menu-button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.setState(prev => ({
                            activePanel: prev.activePanel === 'profile' ? null : 'profile',
                          }));
                        }}
                      >
                        <AccountIcon
                          id="menu-button"
                          role="presentation"
                          focusable={false}
                          fill="currentColor"
                          className="header-account-icon"
                          style={{
                            width: 24,
                            height: 24,
                            color: "#ffffff",
                            display: "block",
                          }}
                        />
                        <span className="header-submenu-button-name">
                          {activeProfile?.firstName ?? ""}
                        </span>
                      </button>
                      {this.state.activePanel === 'profile' && this.state.menuOptions?.length && (
                        <CustomPopup
                          id="header-menu-popup"
                          onClickOutside={() => {
                            this.setState({ activePanel: null });
                          }}
                          isVisible={this.state.activePanel === 'profile'}
                          handleCustomEvent={this.handleMenuItem}
                        >
                          <ul id="header-menu-popup" className="submenu-items">
                            {this.state.menuOptions?.map((option) => (
                              <li key={option.id} data-menu-id={option.id}>
                                <svg
                                  className="ontario-icon"
                                  aria-hidden="true"
                                  focusable="false"
                                  viewBox="0 0 24 24"
                                  preserveAspectRatio="xMidYMid meet"
                                >
                                  <use href={option.icon}></use>
                                </svg>
                                <a
                                  id={option.id}
                                  href="#"
                                >
                                  {this.props.isEng
                                    ? option["title-en"]
                                    : option["title-fr"]}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </CustomPopup>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </section>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        {this.generateHeader()}
        <OntarioConfirmDialog
          visible={this.state.showExitDialog}
          title={this.props.programContainer.ExitPopupTitle || (this.props.isEng ? "Are you sure you want to exit?" : "Êtes-vous sûr de vouloir quitter?")}
          message={this.props.programContainer.ExitPopupMessage || (this.props.isEng ? "If you leave this page your progress will not be saved." : "Si vous quittez cette page, votre progression ne sera pas sauvegardée.")}
          cancelLabel={this.props.programContainer.ExitPopupStayButtonLabel || (this.props.isEng ? "Stay on this page" : "Rester sur cette page")}
          confirmLabel={this.props.programContainer.ExitPopupExitButtonLabel || (this.props.isEng ? "Exit without saving" : "Quitter sans sauvegarder")}
          onCancel={this.handleCancelExit}
          onConfirm={this.handleConfirmExit}
        />
      </>
    );
  }
}
